<template>
  <header
    @scroll="handleScroll"
    :class="[
      this.header.activeClass,
      this.header.showMenu ? 'open' : '',
      this.header.showSearch ? 'search' : ''
    ]"
  >
    <div class="logos">
      <router-link class="logo text-left" to="/">
        <img src="../assets/images/logo-mitsubishi.png" alt="Mitsubishi" />
        <img src="../assets/images/logo-ec-phev.png" alt="Eclipse Cross PHEV" />
      </router-link>
    </div>
    <div class="menu">
      <ul class="menu-list">
        <li>
          <!--<router-link to="/" @click.native="closeMenu"
          >Strona główna</router-link
          >-->
          <a @click="goToHome('home', '/#home')">Strona główna</a>
        </li>
        <li>
          <router-link to="/timeline" @click.native="closeMenu"
            >Historia PHEV</router-link
          >
        </li>
        <li>
          <a @click="goToHome('versions', '/#versions')">Wersje wyposażenia</a>
        </li>
        <li>
          <router-link to="/car-drive" @click.native="closeMenu"
            >Zaawansowana technologia</router-link
          >
        </li>
        <li>
          <!--<a @click="form.showDialog = true">Kontakt on-line</a>-->
          <a href="https://www.mitsubishi.pl/oferta/eclipse-cross-phev" target="_blank">Aktualne promocje</a>
        </li>
      </ul>
      <div class="search-button">
        <i class="fas fa-search" @click="toggleSearch"></i>
      </div>
      <div class="search-bar">
        <v-text-field label="Szukaj" color="#e60013"></v-text-field>
      </div>
    </div>
    
    <div
      class="menu-button"
      @click="toggleMenu"
      :class="[this.header.activeClass, this.header.showMenu ? 'open' : '']"
    >
      <div class="button-wrapper"></div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "Header",
  computed: {
    ...mapGetters({
      header: "header",
      form: "form"
    })
  },
  methods: {
    ...mapMutations({
      handleScroll: "handleScroll",
      toggleSearch: "toggleSearch",
      toggleMenu: "toggleMenu",
      resizeMenu: "resizeMenu",
      closeMenu: "closeMenu"
    }),
    goToHome(link, path) {
      const home = document.querySelector(".home");

      if (home !== null) {
        const versions = document.querySelector(
          `li[data-menuanchor='${link}']`
        );
        versions.dispatchEvent(new Event("click"));
      } else {
        this.$router.push(`${path}`);
      }

      this.closeMenu();
    }
  },
  beforeMount() {
    window.addEventListener("resize", this.resizeMenu);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeMenu);
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
@import "src/styles/mixins";

@mixin sticky-header() {
  background-image: linear-gradient(#0b0b0b, #262626);
  background-color: rgba($black, 0.85);
  top: -100%;
  position: fixed;
  margin-top: 0;
  box-sizing: border-box;
  align-content: flex-start;

  .logos {
    @include size-flex(100%);
  }

  .menu {
    @include size-flex(100% !important);
    padding-top: var(--page-offset);
    position: unset !important;

    .menu-list {
      @include size-flex(100% !important);
      align-self: flex-start !important;

      @media screen and (max-width: $screen-sm) {
        display: block !important;
      }

      li {
        display: block !important;
        flex: 0 0 100% !important;
        text-align: right !important;
        margin-bottom: 2rem !important;

        &:first-of-type {
          display: block;
        }

        &.router-link-active {
          color: $white !important;
        }

        @media screen and (max-width: $screen-sm) {
          margin-bottom: 0rem !important;
          text-align: center !important;
        }

        a {
          display: block !important;
          line-height: 1;
          font-size: 3vw;

          @media screen and (max-height: $screen-height-md) {
            font-size: 2.15vw;
          }

          @media screen and (max-width: $screen-sm) {
            font-size: 1.3rem;
          }
        }
      }
    }
  }

  .search-button {
    display: none;
  }

  .search-bar {
    @include size-flex(100% !important);
    @include set-size(auto !important, auto !important);
    top: auto !important;
    right: calc(2 * var(--page-offset)) !important;
    left: calc(2 * var(--page-offset)) !important;
    bottom: var(--page-offset) !important;
    transform: none !important;
    justify-content: flex-end;
    transition: none;
    align-self: flex-end;
    display: none !important;

    label {
      display: none;
    }

    .v-input {
      transition: none;
      flex: 0 0 25rem !important;
      max-width: 25rem !important;
      border: 1px solid $menu-link-color !important;

      @media screen and (max-width: $screen-sm) {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }
}

@mixin menu-button-settings() {
  @include set-size(2.5rem, 0.25rem);
  background-color: $white;
  border-radius: 0.25rem;
  position: absolute;
  transition-property: transform;
}

header {
  @include set-position(absolute, -5rem, 0, auto, 0);
  @include display-flex(flex, wrap);
  z-index: 199;
  padding: var(--page-offset) calc(2 * var(--page-offset));
  margin-top: 5rem;

  @media screen and (max-width: $screen-sm) {
    @include sticky-header();
    padding-left: var(--page-offset);
    padding-right: var(--page-offset);
  }

  &.normal {
    background-image: linear-gradient(#000, transparent);
  }

  &.sticky {
    @include sticky-header();
  }

  &.open {
    @include set-size(100vw, 100vh);
    top: 0;
    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  &.search {
    .menu-list {
      li {
        a {
          color: transparent !important;
        }
      }
    }

    .search-button {
      i {
        &::before {
          content: "\f00d";
        }
      }
    }

    .search-bar {
      width: calc(100% - 1.5rem);
      transition: width 0.5s cubic-bezier(0.23, 1, 0.32, 1);
    }
  }

  .logos {
    @include size-flex(35%);

    @media screen and (max-width: $screen-xl) {
      @include size-flex(30%);
    }

    @media screen and (max-width: $screen-sm) {
      @include size-flex(calc(100% - 2.5rem));
    }

    .logo {
      img {
        margin-right: 2.5rem;
        vertical-align: middle;

        @media screen and (max-width: $screen-xl) {
          @include set-max-size(10rem, 4rem);
          margin-right: 1.75rem;
        }

        @media screen and (max-width: $screen-lg) {
          @include set-max-size(7rem, 3rem);
        }

        @media screen and (max-width: $screen-sm) {
          @include set-max-size(6rem, 2.5rem);
        }

        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }

  .menu {
    @include display-flex(flex, wrap);
    @include size-flex(65%);
    position: relative;

    @media screen and (max-width: $screen-xl) {
      @include size-flex(70%);
    }
  }

  .menu-list {
    @include display-flex(flex, wrap);
    @include size-flex(100%);
    @include margin-padding(0, 0);
    list-style: none;
    align-self: center;

    @media screen and (max-width: $screen-sm) {
      display: none;
    }

    li {
      flex: 1 0 auto;
      text-align: center;

      &:first-of-type {
        display: none;
      }

      @media screen and (max-width: $screen-sm) {
        text-align: left;
      }

      a {
        @include font-size-weight(1.1rem, 500);
        color: $white;
        text-transform: uppercase;
        text-decoration: none;
        transition: color 0.25s ease-in-out;

        &:hover,
        &.is-active {
          color: $white !important;
        }

        @media screen and (max-width: $screen-xxl + 200px) {
          font-size: 1rem;
        }

        @media screen and (max-width: $screen-xl) {
          font-size: 0.9rem;
          display: table-caption;
          line-height: 1.15;
        }

        @media screen and (max-width: $screen-sm) {
          display: block;
          padding-bottom: var(--page-offset);
        }
      }
    }
  }

  .search-button {
    @include size-flex(5%);
    @include z-index(relative, 1);
    align-self: center;
    text-align: right;
    display: none !important;

    @media screen and (max-width: $screen-sm) {
      display: none;
    }

    i {
      font-size: 1.5rem;
      cursor: pointer;
    }
  }

  .search-bar {
    @include display-flex(flex, wrap);
    @include set-position(absolute, 50%, 1.5rem, auto, auto);
    @include set-size(0, calc(100% - var(--page-offset)));
    transform: translateY(-50%);
    align-content: center;
    transition: none;
  }

  .menu-button {
    @include set-position(fixed, 0, 0, auto, auto);
    @include set-size(calc(3 * var(--page-offset)), 3.375rem);
    background-image: linear-gradient(rgba(#0b0b0b, 0.75), rgba(#262626, 0.75));
    cursor: pointer;
    display: none;
    z-index: -1;
    min-width: 4.5rem;

    &.sticky {
      display: block;
      z-index: 1001;
    }

    @media screen and (max-width: $screen-sm) {
      display: block;
    }

    &.open {
      .button-wrapper {
        transform: translate3d(0, 0.6rem, 0) rotate(135deg);
        transition-delay: 0.075s;
        background-color: $mmc-red;

        &::before {
          transition-delay: 0s;
          opacity: 0;
        }

        &::after {
          transform: translate3d(0, -1.25rem, 0) rotate(-270deg);
          transition-delay: 0.075s;
          background-color: $mmc-red;
        }
      }
    }

    .button-wrapper {
      @include menu-button-settings();
      top: 1rem;
      left: 1rem;
      transition-duration: 0.275s;
      transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);

      &::after,
      &::before {
        @include menu-button-settings();
        content: "";
        display: block;
      }

      &::after {
        top: 1.25rem;
        transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);
      }

      &::before {
        top: 0.6rem;
        transition: opacity 0.125s 0.275s ease;
      }
    }
  }
}
</style>
